import { render, staticRenderFns } from "./DeafultLocationSettingsModal.vue?vue&type=template&id=5b04dc04&"
import script from "./DeafultLocationSettingsModal.vue?vue&type=script&lang=js&"
export * from "./DeafultLocationSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports